import { z } from "zod";
import { IntegrationProvider } from "./integration.js";
const allKnowledgeBaseSyncProviders = [
  IntegrationProvider.KUSTOMER,
  IntegrationProvider.GURU
];
const knowledgeBaseSyncProviderSchema = z.enum(
  allKnowledgeBaseSyncProviders
);
const knowledgeBaseSyncProviderLabels = {
  [IntegrationProvider.KUSTOMER]: "Kustomer",
  [IntegrationProvider.GURU]: "Guru"
};
const DEFAULT_KNOWLEDGE_BASE_SYNC_SCHEDULE = {
  frequency: "daily",
  time_of_day: "08:00"
};
const INITIAL_KNOWLEDGE_BASE_SYNC_AUTOSYNC_ENABLED = false;
function resolveKnowledgeBaseSyncScheduleSettings(settings) {
  return {
    sync_schedule: settings?.sync_schedule ?? DEFAULT_KNOWLEDGE_BASE_SYNC_SCHEDULE,
    autosync_enabled: settings?.autosync_enabled ?? true
  };
}
function maybeGetKnowledgeBaseExternalProvider(metadata) {
  return metadata?.external_provider ?? null;
}
const knowledgeBaseSyncRunIdSchema = z.uuid().brand();
function asKnowledgeBaseSyncRunId(id) {
  return knowledgeBaseSyncRunIdSchema.parse(id);
}
const knowledgeBaseSyncActiveRunSchema = z.object({
  id: knowledgeBaseSyncRunIdSchema,
  status: z.enum(["pending", "running"])
});
export {
  DEFAULT_KNOWLEDGE_BASE_SYNC_SCHEDULE,
  INITIAL_KNOWLEDGE_BASE_SYNC_AUTOSYNC_ENABLED,
  allKnowledgeBaseSyncProviders,
  asKnowledgeBaseSyncRunId,
  knowledgeBaseSyncActiveRunSchema,
  knowledgeBaseSyncProviderLabels,
  knowledgeBaseSyncProviderSchema,
  knowledgeBaseSyncRunIdSchema,
  maybeGetKnowledgeBaseExternalProvider,
  resolveKnowledgeBaseSyncScheduleSettings
};
//# sourceMappingURL=knowledgeBaseSync.js.map
